import React, {useMemo} from "react";
import {useSelector} from "react-redux";

import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {IRPStore} from "../../../../app/rp_reducer";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";
import {findVariableByValue} from "../../../../property/utils/find_variable_by_value";

export const KitchenCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const property = props.item;
    const variables = useSelector((state: IRPStore) => state.variables.data);
    const kitchenType = useMemo(
        () => findVariableByValue(variables?.property_kitchen_type, property.kitchen_type)?.label || "",
        [property.kitchen_type, variables]
    );

    return <>{kitchenType ? `${kitchenType.toLowerCase()} kuchnia` : null}</>;
};
import React, {useMemo} from "react";
import {useSelector} from "react-redux";

import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {IRPStore} from "../../../../app/rp_reducer";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";
import {findVariableByValue} from "../../../../property/utils/find_variable_by_value";

export const KitchenCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const property = props.item;
    const variables = useSelector((state: IRPStore) => state.variables.data);
    const kitchenType = useMemo(
        () => findVariableByValue(variables?.property_kitchen_type, property.kitchen_type)?.label || "",
        [property.kitchen_type, variables]
    );

    return <>{kitchenType ? `${kitchenType.toLowerCase()} kuchnia` : null}</>;
};
